import { Instance } from 'mobx-state-tree';
import { RouteStopUnschedulingFailedDtoModelBase } from './RouteStopUnschedulingFailedDtoModel.base';

/* The TypeScript type of an instance of RouteStopUnschedulingFailedDtoModel */
export interface RouteStopUnschedulingFailedDtoModelType extends Instance<typeof RouteStopUnschedulingFailedDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopUnschedulingFailedDtoModel */
export {
  selectFromRouteStopUnschedulingFailedDto,
  routeStopUnschedulingFailedDtoModelPrimitives,
  RouteStopUnschedulingFailedDtoModelSelector,
}
  from './RouteStopUnschedulingFailedDtoModel.base';

/**
 * RouteStopUnschedulingFailedDtoModel
 *
 * Route unscheduling failed event
 */
export const RouteStopUnschedulingFailedDtoModel = RouteStopUnschedulingFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
